import { render } from "./AddReceiverStatisticalPage.vue?vue&type=template&id=58bfa5da&ts=true"
import script from "./AddReceiverStatisticalPage.vue?vue&type=script&lang=ts"
export * from "./AddReceiverStatisticalPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__